var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82605 6.92751C2.83565 4.10046 5.13522 1.81646 7.96228 1.82606C10.7893 1.83567 13.0733 4.13524 13.0637 6.9623V7.02027C13.0289 8.85795 12.0029 10.5565 10.7449 11.884C10.0255 12.6311 9.22205 13.2925 8.35069 13.855C8.11769 14.0566 7.77209 14.0566 7.53909 13.855C6.2401 13.0095 5.10001 11.9421 4.17098 10.7014C3.34295 9.61957 2.87283 8.30647 2.82605 6.9449L2.82605 6.92751Z",
    stroke: "#E0475B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.9449,
    cy: 7.02605,
    rx: 1.64058,
    ry: 1.64058,
    stroke: "#E0475B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/Location2.c8b432d49b9b59dfd8746781c8765507.svg";
export { ForwardRef as ReactComponent };